export default __webpack_public_path__ + "media/zurb/img/services/process/leap-img-85c78d185b0654a8ed3880e4356359ba.png";